module.exports = __webpack_public_path__ + "static/media/bb-logo.8b6ee30a.svg";